import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StreamingStateService {
  private readonly isStreaming = new BehaviorSubject<boolean>(false);
  public isStreaming$ = this.isStreaming.asObservable();

  setStreamingState(streaming: boolean): void {
    this.isStreaming.next(streaming);
  }

  getCurrentStreamingState(): boolean {
    return this.isStreaming.value;
  }
}
